import { Triplet, usePointToPointConstraint } from "@react-three/cannon";
import { ThreeEvent } from "@react-three/fiber";
import { createRef, forwardRef, RefObject, useCallback, useEffect } from "react";
import { Mesh, Object3D } from "three";

export const cursor = createRef<Mesh>();
export function useDragConstraint(child: RefObject<Object3D>) {
  const [, , api] = usePointToPointConstraint(cursor, child, { pivotA: [0, 0, 0], pivotB: [0, 0, 0] }, []);
  useEffect(() => void api.disable(), []); // memo:最初は無効化
  const onPointerDown = useCallback((e: ThreeEvent<PointerEvent>) => {
    document.body.style.cursor = 'grabbing';
    e.stopPropagation();
    // @ts-expect-error Investigate proper types here.
    e.target.setPointerCapture(e.pointerId);
    api.enable();
  }, []);
  const onPointerUp = useCallback(() => {
    document.body.style.cursor = 'default';
    api.disable();
  }, []);
  return { onPointerDown, onPointerUp };
};


export interface ObjectProps {
  position?: Triplet;
  rotation?: Triplet;
  scale?: Triplet;
}


export interface BoxProps {
  args?: Triplet;
  children?: React.ReactNode;
  color?: string;
  opacity?: number;
  transparent?: boolean;
  [key: string]: any; // その他のプロパティを許可
  isMeshStandardMaterial?: boolean;
}
export const Box = forwardRef<Mesh, BoxProps>(
  ({ args = [1, 1, 1], children, color = 'white', opacity = 1, transparent = false, isMeshStandardMaterial = true, ...props }, ref) => {
    return (
      <mesh castShadow receiveShadow ref={ref} {...props}>
        <boxGeometry args={args} />
        { isMeshStandardMaterial && <meshStandardMaterial color={color} opacity={opacity} transparent={transparent} /> }
        {children}
      </mesh>
    );
  },
);


export interface CylinderProps {
  args?: [radiusTop?: number, radiusBottom?: number, height?: number, radialSegments?: number];
  children?: React.ReactNode;
  color?: string;
  opacity?: number;
  transparent?: boolean;
  [key: string]: any; // その他のプロパティを許可
}
export const Cylinder = forwardRef<Mesh, CylinderProps>(
  ({ args = [0.5, 0.5, 1, 8], children, color = 'white', opacity = 1, transparent = false, ...props }, ref) => {
    return (
      <mesh castShadow receiveShadow ref={ref} {...props}>
        <cylinderGeometry args={args} />
        <meshStandardMaterial color={color} opacity={opacity} transparent={transparent} />
        {children}
      </mesh>
    );
  },
);


export interface SphereProps {  args?: [radius?: number, widthSegments?: number, heightSegments?: number];
  children?: React.ReactNode;
  color?: string;
  opacity?: number;
  transparent?: boolean;
  isMeshStandardMaterial?: boolean;
  [key: string]: any; // その他のプロパティを許可
}
export const Sphere = forwardRef<Mesh, BoxProps>(
  ({ args = [1], children, color = 'white', opacity = 1, transparent = false, isMeshStandardMaterial = true, ...props }, ref) => {
    return (
      <mesh castShadow receiveShadow ref={ref} {...props} >
        <sphereGeometry args={args} />
        { isMeshStandardMaterial && <meshStandardMaterial color={color} opacity={opacity} transparent={transparent} /> }
        {children}
      </mesh>
    );
  }
);
